import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthenticationService } from '@app/_services';
import { ApiBackendService } from '@app/_services/api-backend.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  loading = false;
  error = '';

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public apiBackendService: ApiBackendService
  ) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: [null, [Validators.required]],
    });
  }

  get f() {
    return this.forgotPasswordForm.controls;
  }

  onSubmit() {
    // this.loading = true;
    localStorage.setItem('passwordReset', '1');

    for (const i in this.forgotPasswordForm.controls) {
      this.forgotPasswordForm.controls[i].markAsDirty();
      this.forgotPasswordForm.controls[i].updateValueAndValidity();
    }

    console.log('form', this.forgotPasswordForm.value.email);
    this.router.navigate(['/login']);

    this.apiBackendService
      .forgotPassword(this.forgotPasswordForm.value.email)
      .pipe()
      .subscribe((res) => {
        console.log('res', res);
      });
    // stop here if form is invalid
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    // this.error = 'Acest serviciu este momentan indisponibil.';
  }
}
